<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Visitor List" />
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    <div class="card-header">
                       
                    </div>
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li> 
                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Visitor List:</h6>
                                        <button class="btn btn-primary text-white" v-if="reschedule.length > 0"
                                            data-bs-toggle="modal" data-original-title="test"
                                            data-bs-target="#rescheduleHere">Reschedule</button>
                                    </div>

                            
                                      



                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="visitorlist">
                                                <thead>
                                                    <tr>
                                                  
                                                        <th>SR</th>
                                                        <th>Name</th>
                                                        <th>Firm Name</th>
                                                        <th>Contact</th>
                                                        <th>Photo</th>
                                                        <th>address</th>
                                                        <th>designation</th>
                                                        <th>Action</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in  visitorlist" :key="visitorlist.id">
                                                        <td>{{ index+1 }}</td>       
                                                        <td>{{ item.name }} </td>
                                                        <td>{{ item.firmname }} </td>
                                                        <td>{{ item.contact }}</td>
                                                        <td><img :src="this.$hostname+'writable/uploads/visitors/'+item.photo" v-if="imageUrl" style="height: 50px; width:50px;"/></td>
                                                        <td>{{ item.address }} </td>
                                                        <td>{{ item.designation }}</td>
                                                        <td>
                                                            <span class="badge bg-danger" @click="editlist(item.id)">Edit</span>
                                                          </td>
                                                      
                                                          <td>
                                                            <span class="badge bg-primary" @click="deleteitem(item.id)" >Delete</span>
                                                          </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="showEditModal" class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Visitor</h5>
              <button type="button" class="close" @click="showEditModal = false" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
      
            <div class="modal-body">
              <div class="form-group">

                <input type="hidden" v-model="editvisitorlist.id" />
                
                <div class="col-12 row">
                    
                 <div class="col-6">
                <label>Name</label>
                <input type="text" v-model="editvisitorlist.name" class="form-control" />
              </div>
              

              <div class="col-6">

              <div class="form-group">
                <label>Firm Name</label>
                <input type="text" v-model="editvisitorlist.firmname" class="form-control" />
              </div>

              </div>

              </div>
              </div>



              <div class="col-12 row">
                <div class="col-6">
              <div class="form-group">
                <label>Contact</label>
                <input type="text" v-model="editvisitorlist.contact" class="form-control" />
              </div>
              </div>


              <div class="col-6">
              <div class="form-group">
                <label>Designation</label>
                <input type="text" v-model="editvisitorlist.designation" class="form-control" />
              </div>

              </div>
              </div>




              <div class="form-group">
                <label>Photo</label><br>
                <input type="file" @change="handlePhotoUpload" class="form-control-file" />
                <div class="col-12 row">
                
                <div class="col-6">
                
                <label>Selected Photo</label><br>

                <img :src="imageUrls" v-if="imageUrls" alt="Uploaded Image" style="height: 80px;width: 80x; border-radius: 80%;"/><br>

                </div>

                <div class="col-6">
             
                <label>Server Photo</label><br>
                <img :src="this.$hostname+'writable/uploads/visitor/'+editvisitorlist.photo" v-if="imageUrl" alt="Uploaded Image" style="height: 80px;width: 80x; border-radius: 50%;" />
                </div>
                </div>


              </div>





    
           
              <div class="form-group mt-2">
                <label>Address</label>
                <textarea v-model="editvisitorlist.address" class="form-control"></textarea>
              </div>
             
          
              
            
            
       


            </div>
      
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="updatevisitor">Save changes</button>
            </div>
          </div>
        </div>
      </div>
  


</template>
<style scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}

.badge_sm {
    padding: 2px 5px;
    border-radius: 10px;
    font-size: smaller;
    color: white;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getBasics();
        

    }, data() {
       
        return {
            imageUrl: this.$hostname,//"https://vms.dktsoft.in/backend/writable/editvisitorlist.photo",
            reschedule: [],
            user: [],
            editvisitorlist: {
            id:'',
            name: '',
            firmname: '',
            contact: '',
            photos: '',
            address: '',
            designation: '',
            authtoken:'',
            },
            imageUrls: null, 

            visitorlist:[],
            
            showEditModal: false,
            sd:0,
          
      

        }
    }, 
    methods: {
        getBasics() {
            var self = this;
            axios.post('getvisitorlist').then(function (response) {
                self.visitorlist = response.data.visitorlist;
                window.scrollTo(0, 0);
            }).then(() => {
               self.dataTable= $(".datatable").DataTable({
                    dom: 'Bfrtip',
                    buttons: ['excel', 'pdf'],
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false
                });
            });


        },
    handlePhotoUpload(event) {
        const file = event.target.files[0]; // Get the file selected by the user
        if (file) {
            this.editvisitorlist.photos = file; // Store the file in editvisitorlist
            // Create a temporary URL for the image file for preview
            this.imageUrls = URL.createObjectURL(file);
        }
    },
      


        deleteitem(id) {
        var self = this;
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
        if (result.isConfirmed) {
            axios.post('deletevisitorlist', { id: id }).then(function (response) {
                self.visitorlist = response.data.visitorlist;
                self.message = response.data.message;
                
                self.$swal(self.message);

                window.scrollTo(0, 0);
              
            });
        }
    });
},


        editlist(id) {

            var self = this;
            axios.post('editvisitorlist', { id: id }).then((response) => {
               
                self.editvisitorlist = response.data.visitorlist;

                self.showEditModal = true;

              

                window.scrollTo(0, 0);

            }).catch((error) => {
                console.error('Error editing item:', error);
            });
        },




        destroyTable(){
                if ($.fn.dataTable.isDataTable('#visitorlist')) {
                                    $('#visitorlist').DataTable().destroy();
                                }
                            },

            refreshTable(){
                    $("#visitorlist").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                },




            updatevisitor() {
                var self = this;
                axios.post('updatevisitor',self.editvisitorlist, {
            headers: {
               'Content-Type': 'multipart/form-data' 
          }}).then(function (response) {
                   self.destroyTable();
                    self.visitorlist = response.data.visitorlist;
                    self.status = response.data.status;
                    self.message = response.data.message;
                   
         
                        self.$swal(self.message);
                        self.showEditModal = false;
            

                    window.scrollTo(0, 0);
                }).then(() => {
                    self.refreshTable();
              
                });


            },


    






     
          
    }
}
</script>

<style>
    .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-wrapper {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
}

    </style>
